export const SLAsByServiceKey = 'slas-by-service';
export const SLATimeoutAtKey = 'slas-timeout-at';
export const SLAScopesKey = 'sla-scopes';
export const SLATypesKey = 'sla-types';
export const SLATargetTypesKey = 'sla-target-types';
export const SLAConfigsKey = 'sla-configs';
export const OutcomeReasonsKey = 'outcome-reasones';
export const OutcomeReviewsKey = 'outcome-reviews';
export const SLAConfigMetaDataKey = 'sla-config-meta-data';